import { motion } from "framer-motion";
import { SOCIALS } from "../data/content";
import BrandIcon from "./BrandIcons";

// Compact chrome social icon row for nav / footer.
export default function SocialBar({ size = 18, className = "", gap = "gap-3" }) {
  return (
    <div className={`flex items-center ${gap} ${className}`} data-testid="social-bar">
      {SOCIALS.map((s) => (
        <motion.a
          key={s.icon}
          href={s.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={s.label}
          data-testid={`socialbar-${s.icon}`}
          data-cursor
          whileHover={{ y: -3 }}
          transition={{ type: "spring", stiffness: 400, damping: 18 }}
          className={`text-white/55 hover:text-white transition-colors duration-300 ${s.secondary ? "opacity-70" : ""}`}
        >
          <BrandIcon name={s.icon} size={size} />
        </motion.a>
      ))}
    </div>
  );
}
